import dayjs from 'dayjs';

export const sortNumbers = (v1, v2) => {
    if (v1 == null && v2 == null) return 0;
    if (v1 == null) return 1;
    if (v2 == null) return -1;
    // Convert string values to numbers for comparison
    const num1 = typeof v1 === 'string' ? parseFloat(v1) : v1;
    const num2 = typeof v2 === 'string' ? parseFloat(v2) : v2;
    return num1 - num2;
};

export const sortStrings = (v1, v2) => {
    if (v1 == null && v2 == null) return 0;
    if (v1 == null) return 1;
    if (v2 == null) return -1;
    return v1.localeCompare(v2);
};

export const sortBooleans = (v1, v2) => {
    if (v1 == null && v2 == null) return 0;
    if (v1 == null) return 1;
    if (v2 == null) return -1;
    return v1 ? 1 : -1;
};

export const sortDayjsDates = (v1, v2, descending = false) => {
    if (v1 == null && v2 == null) return 0;
    if (v1 == null) return 1;
    if (v2 == null) return -1;

    if (!v1.isValid() && !v2.isValid()) return 0;
    if (!v1.isValid()) return 1;
    if (!v2.isValid()) return -1;

    const diff = v1.diff(v2);
    return descending ? -diff : diff;
};
